import Quill from 'quill/core';

const Module = Quill.import('core/module');

class ChildHistory extends Module {
  constructor(quill: Quill, options: Record<string, unknown>) {
    super(quill, options);

    // Copied from quill's history module
    this.quill.keyboard.addBinding(
      { key: 'z', shortKey: true },
      this.undo.bind(this),
    );
    this.quill.keyboard.addBinding(
      { key: 'z', shortKey: true, shiftKey: true },
      this.redo.bind(this),
    );
    if (/Win/i.test(navigator.platform)) {
      this.quill.keyboard.addBinding(
        { key: 'y', shortKey: true },
        this.redo.bind(this),
      );
    }
  }

  get parentQuill() {
    // @ts-expect-error
    return this.options.parentQuill;
  }

  clear() {
    // Don't clear parent's history
  }

  cutoff() {
    this.parentQuill.history.cutoff();
  }

  undo() {
    this.parentQuill.history.undo();
  }

  redo() {
    this.parentQuill.history.redo();
  }
}

export default ChildHistory;
